import { ReactElement } from 'react';

import { useTranslation } from 'modules/i18n';
import { IotaWalletIcon } from 'modules/icons';

import { WalletId } from '../../const';
import { ConnectButton } from '../ConnectButton';
import { translation } from './translation';

const INSTALL_WALLET_LINK =
  'https://chromewebstore.google.com/detail/iota-wallet/iidjkmdceolghepehaaddojmnjnkkija';

export function IotaWalletConnectButton(): ReactElement {
  const { t, keys } = useTranslation(translation);
  return (
    <ConnectButton
      icon={<IotaWalletIcon height={36} width={36} />}
      installWalletLink={INSTALL_WALLET_LINK}
      name={t(keys.iotaWallet)}
      walletId={WalletId.iota}
    />
  );
}
